import {
  createElement,
  type CSSProperties,
  type ReactElement,
  type ReactNode,
} from 'react';
import { cn } from '../../../lib/utils.ts';
import {
  FreeformSlideFrame,
  type FreeformSlideData,
} from '../freeform/FreeformSlideFrame.ts';
import { FAN_SLIDE_CARD, type SlideThemeFonts } from '../slideFrame.ts';

export type FanFreeformCanvasData = FreeformSlideData;

/** 16:9 FREEFORM frame inside the Fan slide card. No QR on Fan. */
export function FanFreeformSlideCard({
  slideId,
  slideData,
  entranceClassName,
  themeFonts,
  themeBackdrop,
  children,
}: {
  slideId?: string | null;
  slideData: FanFreeformCanvasData | null;
  entranceClassName?: string;
  themeFonts?: SlideThemeFonts | null;
  themeBackdrop?: CSSProperties;
  children?: ReactNode;
}): ReactElement {
  const outerWidth = `calc(100% - ${FAN_SLIDE_CARD.marginPx * 2}px)`;
  return createElement(
    'div',
    {
      'data-name': 'FAN-SLIDES-FREEFORM-CARD',
      className: cn(
        'relative z-10 box-border overflow-hidden rounded-lg bg-white shadow-sm',
      ),
      style: {
        margin: FAN_SLIDE_CARD.marginPx,
        padding: FAN_SLIDE_CARD.paddingPx,
        width: outerWidth,
      },
    },
    createElement(
      'div',
      {
        'data-name': 'FAN-SLIDES-FREEFORM-INNER',
        className: 'overflow-hidden',
        style: { width: '100%', aspectRatio: '16 / 9' },
      },
      createElement(FreeformSlideFrame, {
        key: slideId || undefined,
        slideId,
        slideData,
        entranceClassName,
        fill: 'contain',
        themeFonts,
        themeBackdrop,
      }),
    ),
    children,
  );
}
